var kulczynskiD = require('./../distances/kulczynski');

module.exports = function kulczynski(a, b) {
    return 1 / kulczynskiD(a, b);
};



// WEBPACK FOOTER //
// ./node_modules/ml-distance/src/similarities/kulczynski.js